export default 'Solution Éco France — Financez vos travaux, allégez vos factures d\'énergie';
